import { useObservableState } from 'observable-hooks';
import { ReactNode } from 'react';
import { Observable } from 'rxjs';

export const FromObservable = <T extends any>({
  $,
  children,
  init,
}: {
  $: Observable<T>;
  children?: (value: T | null) => ReactNode | ReactNode[] | null;
  init?: T;
}) => {
  const value = useObservableState($, init || null);
  return <>{children ? (children(value) as any) : value}</>;
};
